export const DATA_HOOKS = {
    WSR_DATE_PICKER: 'wsr-date-picker',
    DATE_INPUT: 'date-input',
};
//# sourceMappingURL=constants.js.map